// packages/components/src/admin/transactions/GlobalTransactionList.tsx
import React, { useState } from 'react';
import { useAllTransactions } from '@dopomogai/agent-kit';
import { Card, Spinner, Alert, Button, Icon, Badge } from '@dopomogai/ui';

const ITEMS_PER_PAGE = 25;

export const GlobalTransactionList: React.FC = () => {
  const [offset, setOffset] = useState(0);
  const { transactions, total, isLoading, error, mutate } = useAllTransactions(ITEMS_PER_PAGE, offset);

  const totalPages = Math.ceil(total / ITEMS_PER_PAGE);
  const currentPage = Math.floor(offset / ITEMS_PER_PAGE) + 1;

  const handleNext = () => {
    if (currentPage < totalPages) {
      setOffset(offset + ITEMS_PER_PAGE);
    }
  };

  const handlePrev = () => {
    if (offset > 0) {
      setOffset(offset - ITEMS_PER_PAGE);
    }
  };
  
  return (
    <Card 
        title="All Transactions"
        actionButton={
            <div className="flex items-center gap-4">
                <span className="text-sm text-slate-500">
                    Page {currentPage} of {totalPages} ({total} items)
                </span>
                <Button size="sm" variant="outline" onClick={handlePrev} disabled={offset === 0 || isLoading}>Prev</Button>
                <Button size="sm" variant="outline" onClick={handleNext} disabled={currentPage >= totalPages || isLoading}>Next</Button>
            </div>
        }
    >
        <div className="font-bold grid grid-cols-12 gap-4 p-3 bg-slate-100 border-b-2 border-slate-200 text-sm text-slate-600 uppercase">
            <div className="col-span-3">User</div>
            <div className="col-span-2">Type</div>
            <div className="col-span-4">Description</div>
            <div className="col-span-1 text-right">Amount</div>
            <div className="col-span-2 text-right">Date</div>
        </div>
        {isLoading ? (
            <div className="flex justify-center items-center p-16">
                <Spinner text="Loading transactions..." />
            </div>
        ) : error ? (
            <Alert type="error" title="Failed to load transactions" message={error.message} />
        ) : (
            <div>
                {transactions.length === 0 ? (
                    <p className="text-center text-slate-500 p-8">No transactions found.</p>
                ) : (
                    transactions.map(tx => (
                        <div key={tx.id} className="grid grid-cols-12 gap-4 items-center p-3 border-b border-slate-200 text-sm">
                            <div className="col-span-3">
                                <p className="font-medium text-slate-800">{tx.users?.name || 'N/A'}</p>
                                <p className="text-xs text-slate-500">{tx.users?.email}</p>
                            </div>
                            <div className="col-span-2"><Badge text={tx.transaction_type} /></div>
                            <div className="col-span-4 text-slate-600 truncate">{tx.description}</div>
                            <div className={`col-span-1 text-right font-semibold ${tx.amount > 0 ? 'text-green-600' : 'text-red-600'}`}>
                                {tx.amount > 0 ? '+' : ''}{tx.amount.toFixed(2)}
                            </div>
                            <div className="col-span-2 text-right text-slate-500">{new Date(tx.created_at).toLocaleString()}</div>
                        </div>
                    ))
                )}
            </div>
        )}
    </Card>
  );
};